import { FETCH_POSTS, NEW_POST } from 'reducers/constants';

const initialState = {
    items: [],
    item: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_POSTS:
            return {
                ...state,
                items: action.payload
            }

        case NEW_POST:
            return {
                ...state,
                item: action.payload
            }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/posts/postReducer.js